(function(angular){
	'use strict';
	
	angular
		.module('campaignsModule')
		.controller('Campaigns', [
			'$cookies',
			'APP_BASE_PATH',
			'globalConfig',
			'mixpanelFactory',
			CampaignsFunction
		]);
	
	function CampaignsFunction(
		$cookies,
		APP_BASE_PATH,
		globalConfig,
		mixpanelFactory){
		
		var campaigns = this;

		if(angular.isDefined(globalConfig.ctaDestination)) {
			campaigns.ctaDestination = APP_BASE_PATH + globalConfig.ctaDestination;
		} else {
			campaigns.ctaDestination = APP_BASE_PATH + '/start-investing';
		}

		if(globalConfig.includeLandingAbTest){

			var cookieJson = $cookies.get('com.fundrise.landing');

			if (cookieJson) {
				var landingCookie = JSON.parse(cookieJson);
				
				if(landingCookie.abTest) {
					campaigns.requireEmail = landingCookie.requiresEmail;
					mixpanelFactory.register({ 'AB Landing Test Cookie' : cookieJson });
					mixpanelFactory.track('AB Test Landing Page Viewed', landingCookie);
				}
			}
			
			if(angular.isUndefined(campaigns.requireEmail)) {
				mixpanelFactory.track('Mixpanel AB Test Cookie Error', {'Cookie Value' : cookieJson});
				campaigns.requireEmail = false;
			}
		} else if(globalConfig.randomEmailCapture) {
			if(Math.floor(Math.random() * 2) === 1) {
				campaigns.requireEmail = true;
			}
			else {
				campaigns.requireEmail = false;
			}
			
			mixpanelFactory.track('AB Test Email Capture', {
				'Email Capture' : campaigns.requireEmail
			});
			
		} else {
			campaigns.requireEmail = true;
		}
	}
})(window.angular);